/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SAPFiscalIdEntry } from './SAPFiscalIdEntry';
import {
    SAPFiscalIdEntryFromJSON,
    SAPFiscalIdEntryFromJSONTyped,
    SAPFiscalIdEntryToJSON,
} from './SAPFiscalIdEntry';

/**
 * Request body for submitting fiscal ID entries on a cart.
 * @export
 * @interface SAPFiscalIdRequest
 */
export interface SAPFiscalIdRequest {
    /**
     * ISO 3166-1 alpha-2 country code for all submitted fiscal ID entries (for example, PT, ES, or BR). Required when the store's sapFiscalIdMode is SAP_REQUIRED_UNCHECKED or SAP_REQUIRED_STRICT.
     * @type {string}
     * @memberof SAPFiscalIdRequest
     */
    sapCountry: string;
    /**
     * List of fiscal ID entries to validate and save. At least one entry is required when the store is in a required mode. Maximum 5 entries per request.
     * @type {Array<SAPFiscalIdEntry>}
     * @memberof SAPFiscalIdRequest
     */
    sapFiscalIdEntries?: Array<SAPFiscalIdEntry>;
}

/**
 * Check if a given object implements the SAPFiscalIdRequest interface.
 */
export function instanceOfSAPFiscalIdRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sapCountry" in value;

    return isInstance;
}

export function SAPFiscalIdRequestFromJSON(json: any): SAPFiscalIdRequest {
    return SAPFiscalIdRequestFromJSONTyped(json, false);
}

export function SAPFiscalIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPFiscalIdRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sapCountry': json['sapCountry'],
        'sapFiscalIdEntries': !exists(json, 'sapFiscalIdEntries') ? undefined : ((json['sapFiscalIdEntries'] as Array<any>).map(SAPFiscalIdEntryFromJSON)),
    };
}

export function SAPFiscalIdRequestToJSON(value?: SAPFiscalIdRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sapCountry': value.sapCountry,
        'sapFiscalIdEntries': value.sapFiscalIdEntries === undefined ? undefined : ((value.sapFiscalIdEntries as Array<any>).map(SAPFiscalIdEntryToJSON)),
    };
}

